import React, { useState, useEffect, Fragment } from 'react';
import {
  Row,
  Input,
  FormGroup,
  CustomInput,
  Button,
  ButtonGroup,
  Form,
  Modal,
  ModalBody,
  InputGroup,
  Label
} from 'reactstrap';
import {
  Colxx,
  Separator,
} from '../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import {
  gAPI_Property_List_By_Group,
  API_SALESFORCE,

  gAPI_Ingetration,
} from '../../../../../constants/APIs';
import { changeSalesforceId } from '../../../../../redux/actions';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import Validation from '../../../../../components/Validation';
let arr = [];
function SalesforceIntegration({ visible, toggle, id }) {
  const [property, setProperty] = useState([]);
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const [maskData, setMaskData] = useState({
    clientId: '',
    clientSecretKey: '',
  });
  const [inputData, setInputData] = useState({
    GroupId: getGroupID(),
    Name: '',
    Properties: [],
    SessionTimeoutInSeconds: 600,
    DefaultLanguage: 'en-US',
    clientId: '',
    clientSecretKey: '',
    domainName: '',
  });
  useEffect(() => {
    if (id !== undefined) {
      AxiosAPI({
        method: 'get',
        url: `${API_SALESFORCE}/${id}?group_id=${getGroupID()}`,
      })
        .then((res) => {
          console.log(res.data, id);
          setInputData({
            ...inputData,
            Name: res.data.name,
            Properties:
              res.data.properties !== null ? [res.data.properties[0]] : [],
            clientId: (res.data.salesforceInetgration.clientId),
            clientSecretKey: (res.data.salesforceInetgration.clientSecretKey),
            domainName: (res.data.salesforceInetgration.domainName),
          });

          setMaskData({
            ...maskData,
            clientId: mask(res.data.salesforceInetgration.clientId),
            clientSecretKey: mask(res.data.salesforceInetgration.clientSecretKey),
          });
        });
      // .catch((err) => console.log('err', err));

      AxiosAPI({
        method: 'get',
        url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
      })
        .then((res) => {
          setProperty([...res.data]);
        })
        .catch((err) => console.error(err));
    } else {
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
      })
        .then((res) => {
          setProperty([...res.data]);
        })
        .catch((err) => console.error(err));
    }
  }, [id]);
  const mask = (value) => {
    console.log(value);
    let maskedValue = '';
    for (let i = 0; i < value.length - 2; i++) {
      maskedValue += '*';
    }
    return maskedValue + value.substring(value.length - 2, value.length);
  };

  const handleNameChange = (e) => {
    e.persist();
    setInputData({ ...inputData, Name: e.target.value });
  };

  const handleClientKeyChange = (e) => {
    e.persist();
    setMaskData({ ...maskData, clientId: mask(e.target.value) });
    setInputData({ ...inputData, clientId: e.target.value });
    //console.log(inputData)
  };
  const handleClientSecretChange = (e) => {
    e.persist();
    setMaskData({ ...maskData, clientSecretKey: mask(e.target.value) });
    setInputData({ ...inputData, clientSecretKey: e.target.value });
    //console.log(inputData)
  };
  const handleDomainName = (e) => {
    e.persist();
    setInputData({ ...inputData, domainName: e.target.value });
    console.log(inputData);
  };
  const handleCheckChange = (e) => {
    if (e.target.checked) {
      setInputData({ ...inputData, Properties: [e.target.value] });
    }
    if (!e.target.checked) {
      setInputData({ ...inputData, Properties: [] });
    }
  };

  const handleSave = async () => {
    if (inputData.clientId !== "" && inputData.clientSecretKey !== "") {

      if (id !== undefined) {
        AxiosAPI({
          method: 'put',
          url: `${API_SALESFORCE}/${id}?group_id=${getGroupID()}`,
          data: inputData,
        }).then((res) => {
          if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
            && res.data.Messages !== null && res.data.Messages.length > 0) {
            setMsg(res.data.Messages);
            setOpen(true);
          }
          else {
            toggle();
            changeSalesforceId(id);
            setTimeout(() => {
              window.location.href = `https://${inputData.domainName}/services/oauth2/authorize?response_type=code&client_id=${inputData.clientId}&scope=offline_access api&redirect_uri=${process.env.REACT_APP_SALESFORCE_REDIRECT_URL}&nonce=${id}`
            }, 300);
          }
        });
      } else {
        AxiosAPI({
          method: 'post',
          url: API_SALESFORCE,
          data: inputData,
        }).then((res) => {
          if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
            && res.data.Messages !== null && res.data.Messages.length > 0) {
            setMsg(res.data.Messages);
            setOpen(true);
          }
          else {
            toggle();
            changeSalesforceId(res.data.id);
            setTimeout(() => {
              window.location.href = `https://${inputData.domainName}/services/oauth2/authorize?response_type=code&client_id=${inputData.clientId}&scope=offline_access api&redirect_uri=${process.env.REACT_APP_SALESFORCE_REDIRECT_URL}&nonce=${res.data.id}`
            }, 300);
          }
        });
      }
    }
  };
  return (
    <Fragment>
      <Modal isOpen={visible} toggle={toggle}>
        <ModalBody>
          <Row className="mb-4">
            <Colxx xxs="12">
              <div className="text-center">
                <h6>{id === undefined ? "Add" : "Update"} Intregation</h6>
                <Separator className="mb-3" />
                <Form className="text-left">
                  <FormGroup className="mb-2">
                    <Label>Integration Name</Label>
                    <Input
                      type="text"
                      name="integrationName"
                      onChange={handleNameChange}
                      placeholder="Integration Name"
                      defaultValue={inputData.Name}
                    />
                  </FormGroup>
                  <FormGroup className="mb-2">
                    <Label>Client Id</Label>
                    <Input
                      type="clientId"
                      name="clientId"
                      onChange={handleClientKeyChange}
                      placeholder="Client Id"
                      defaultValue={maskData.clientId}
                    />
                  </FormGroup>
                  <FormGroup className="mb-2">
                    <Label>Client Secret key</Label>
                    <Input
                      type="text"
                      name="apiSecret"
                      onChange={handleClientSecretChange}
                      placeholder="Client Secret key"
                      defaultValue={maskData.clientSecretKey}
                    />
                  </FormGroup>
                  <FormGroup className="mb-2">
                    <Label>Domain Name</Label>
                    <Input
                      type="text"
                      name="domainName"
                      onChange={handleDomainName}
                      placeholder="Domain Name"
                      defaultValue={inputData.domainName}
                    />
                  </FormGroup>
                  <FormGroup className="mt-3">
                    <div className='integration-property'>
                      {property.map((p, index) => {
                        return (
                          <CustomInput
                            key={p.id}
                            type="radio"
                            id={index}
                            label={p.name}
                            value={p.id}
                            name="property"
                            checked={
                              p.id === inputData.Properties[0] ? true : false
                            }
                            onChange={handleCheckChange}
                          />
                        );
                      })}
                    </div>
                  </FormGroup>
                </Form>
                <ButtonGroup className="mb-2" style={{ marginTop: '20px' }}>
                  {id === undefined ? (
                    <Button color="primary" size="xs" onClick={handleSave}>
                      Create New Intregation
                    </Button>
                  ) : (
                    <Button color="primary" size="xs" onClick={handleSave}>
                      Update Intregation
                    </Button>
                  )}
                  <Button size="xs" color="dark" outline onClick={toggle}>
                    Cancel
                  </Button>
                </ButtonGroup>
              </div>
            </Colxx>
          </Row>
        </ModalBody>
      </Modal>
      <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
    </Fragment>
  );
}
const mapStateToProps = ({ }) => {

};

export default injectIntl(connect(mapStateToProps, { changeSalesforceId })(SalesforceIntegration));

